import { snakeCase } from 'lodash-es';

export const yoyChangeKey = 'year_over_year';
export const popChangeKey = 'period_over_period';
export const intraPeriodKey = 'intra_period';

export const periodChangeTypes = [yoyChangeKey, popChangeKey];

export const periodChangeTypeOptions = [
  {
    value: yoyChangeKey,
    label: 'Year-over-Year',
    shortLabel: 'YoY',
  },
  {
    value: popChangeKey,
    label: 'Period-over-Period',
    shortLabel: 'PoP',
  },
];

export const periodChangeTypeCaptures = {
  [yoyChangeKey]: 'YoY',
  [popChangeKey]: 'PoP',
};

export const intraPeriodChangeTypeOption = {
  label: 'Intra-Period (raw data)',
  value: intraPeriodKey,
};

export const isYoYChange = (changeType) => snakeCase(changeType) === yoyChangeKey;
export const isPoPChange = (changeType) => snakeCase(changeType) === popChangeKey;
export const isIntraPeriod = (changeType) => snakeCase(changeType) === intraPeriodKey;
